import { useField } from "formik";
import React from "react";
import ErrorText from "./ErrorText";
import { Textarea, TextareaProps } from "@mantine/core";

type YoTextFieldProps = React.PropsWithChildren<
  {
    name: string;
  } & TextareaProps
>;

const FormikAwareTextArea = ({ name, ...props }: YoTextFieldProps) => {
  const [field, meta, helpers] = useField<string>(name);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    helpers.setValue(e.target.value);
    helpers.setTouched(true, false);
  };

  const handleBlur = () => {
    helpers.setTouched(true, false);
  };

  return (
    <div>
      <Textarea
        {...props}
        value={field.value}
        name={field.name}
        onChange={handleChange}
        onBlur={handleBlur}
        className={meta.touched && meta.error ? "input-error" : ""}
      />
      {meta.touched && meta.error && <ErrorText text={meta.error} />}
    </div>
  );
};

export default FormikAwareTextArea;
